import { render } from "./DropSkeleton.vue?vue&type=template&id=0ffcc482&scoped=true"
import script from "./DropSkeleton.vue?vue&type=script&lang=js"
export * from "./DropSkeleton.vue?vue&type=script&lang=js"

import "./DropSkeleton.vue?vue&type=style&index=0&id=0ffcc482&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-0ffcc482"

export default script